import * as Utils from './utils'

const PATH_I18N = './i18n/';

// Loaded language data
let L;

/**
 * Load language config file.
 * @param {String} lang File name of language JSON file witout extension.
 */
export const load = async lang => {
    // console.log(`${PATH_I18N}${lang}.json`);
    return await Utils.loadAndParseJSON(`${PATH_I18N}${lang}.json`)
        .then(async data => {
            L = data;
            return await feedLanguageData(L);
        })
}

export const feedLanguageData = async (data) => {
    console.log('feedLanguageData', data);

    // Check through parameters
    for (let param in data) {
        let val = data[param];
        // console.log(param, val);
        // console.log(typeof (val))
        // Straight strings
        if (typeof (val) === 'string') {
            let matched = document.querySelectorAll(`.${param}`);
            if (!matched) {
                if (param === 'title') {
                    document.title = val;
                }

                return;
            }
            matched.forEach(el => {
                el.innerHTML = val;
            })
        }
        // Array values. Like Steps
        else if (typeof (val) === 'array' || typeof (val) === 'object') {

            let wrappers = document.querySelectorAll(`.${param}`);
            // console.log(val)
            // console.log(param)
            // console.log(wrappers)
            if (!wrappers) {
                return;
            }
            // console.log(val.length);
            // Look through wrappers. like <ul>
            wrappers.forEach(wrapper => {
                // loop for JSON array of steps
                for (let inner_loop = 0; inner_loop < val.length; inner_loop += 1) {
                    // loop for values in a step
                    for (let inner_param in val[inner_loop]) {
                        console.log(inner_param, val[inner_loop][inner_param]);
                        let matches = wrapper.querySelectorAll(`.${inner_param}`);
                        if (matches.length > 0 && matches[inner_loop]) {
                            matches[inner_loop].innerHTML = val[inner_loop][inner_param];
                        }
                    }
                }
            })
        }

    }

}


